import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconChevronUp = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z" }, void 0) }, void 0));
const Memo = memo(SvgIconChevronUp);
export default Memo;
//# sourceMappingURL=IconChevronUp.js.map